import {
	FETCH_TSM_LEADERBOARD,
	SHOW_ALERT,
	FETCH_TSM_EARNING,
	EDIT_TSM_NUMBER,
	FETCH_TSM_GMV,
	FETCH_TSM_TARGETS,
	FETCH_ALL_TSM_TARGETS,
	UPDATE_TSM_TARGETS,
	UPDATE_TSM_CSV_FILEPATH,
	FETCH_ALL_DSTR_TARGETS,
	UPDATE_DSTR_CSV_FILEPATH,
	FETCH_RETAIL_ALERTS,
	ADD_RETAIL_ALERTS,
	RESCHEDULE_RETAIL_ALERTS,
	GET_USER_ACTIVE_ALERTS,
	CHANGE_ALERT_STATUS,
	FETCH_USER_METRIC_LEADERBOARDS,
	FETCH_METRIC_LEADERBOARDS,
	UPSERT_METRIC_LEADERBOARDS,
	RETAILERS_VISIT_LIST,
	UPDATE_RETAILER_STATUS,
	RETAIL_VISIT,
	GET_RETAILER_OTP,
	UPDATE_EXISTING_RETAILER,
	FETCH_ALL_RETAIL_VISITS,
	GET_RETAILER_VISIT_HISTORY,
	SCHEDULE_RETAIL_VISIT
} from "../action-types";
import {} from "../mutation-types";
import { DEFAULT_ERROR_MESSAGE } from "../config";
import { BASE_URL } from "../../../config";
import ApiService from "../api-service";

const state = {};

const actions = {
	[FETCH_TSM_LEADERBOARD.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/tsmLeaderboard";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if (typeof data === "object") {
					if (
						data.statusCode === 200 &&
						"response" in data &&
						typeof data.response === "object"
					) {
						const {
							leaderboard = [],
							prizes = [],
							aggregatedGmv = 0,
							aggregatedGmvFantasyOffline = 0,
							aggregatedGmvFantasyTotal = 0,
							aggregatedGmvRummyOffline = 0,
							aggregatedGmvRummyTotal = 0,
							aggregatedGmvLudoTotal = 0
						} = data.response;
						return {
							leaderboard,
							prizes,
							aggregatedGmv,
							aggregatedGmvFantasyOffline,
							aggregatedGmvFantasyTotal,
							aggregatedGmvRummyOffline,
							aggregatedGmvRummyTotal,
							aggregatedGmvLudoTotal
						};
					} else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[FETCH_TSM_EARNING.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/tsmMonthlyEarning";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if (typeof data === "object") {
					if (
						data.statusCode === 200 &&
						"response" in data &&
						typeof data.response === "object"
					) {
						const { amount = 0 } = data.response;
						return { amount };
					} else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[EDIT_TSM_NUMBER.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/updateRetailers";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if (typeof data === "object") {
					if (
						data.statusCode === 200 &&
						"response" in data &&
						typeof data.response === "object"
					) {
						dispatch(
							SHOW_ALERT.dispatch,
							{ text: "Tsm Number Changed Successfully!" },
							{ root: true }
						);
						return;
					} else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[FETCH_TSM_GMV.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/tsmGmv";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if (typeof data === "object") {
					if (
						data.statusCode === 200 &&
						"response" in data &&
						data.response.length > 0
					) {
						const {
							gmvRummyTotal = 0,
							gmvFantasyTotal = 0,
							gmvLudoTotal = 0
						} = data.response[0];
						return { gmvRummyTotal, gmvFantasyTotal, gmvLudoTotal };
					} else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[FETCH_TSM_TARGETS.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/getRetailUserTarget";
		const { appType } = payload;
		const headers = {
			"x-client-app-type": appType
		};
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload, { headers })
			.then(data => {
				if (typeof data === "object") {
					if (
						data.statusCode === 200 &&
						"response" in data &&
						typeof data.response === "object"
					) {
						const {
							targets = [],
							startDate,
							endDate
						} = data.response;
						return { targets, startDate, endDate };
					} else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[FETCH_ALL_TSM_TARGETS.action]: ({ rootState, dispatch }, payload) => {
		const endpoint =
			BASE_URL + "/jeet11-retail/v1.0.0/getAllRetailUserTarget";
		const { appType } = payload;
		const headers = {
			"x-client-app-type": appType
		};
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload, { headers })
			.then(data => {
				if (typeof data === "object") {
					if (
						data.statusCode === 200 &&
						"response" in data &&
						typeof data.response === "object"
					) {
						return data.response;
					} else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[UPDATE_TSM_TARGETS.action]: ({ rootState, dispatch }, payload) => {
		const endpoint =
			BASE_URL + "/jeet11-retail/v1.0.0/upsertRetailUserTarget";
		const { appType, targets, startDate, endDate, userId } = payload;
		const headers = {
			"x-client-app-type": appType
		};
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				targets,
				startDate,
				endDate,
				userId
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload, { headers })
			.then(data => {
				if (typeof data === "object") {
					if (
						data.status === "success" &&
						"response" in data &&
						typeof data.response === "object"
					) {
						return data.response;
					} else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[UPDATE_TSM_CSV_FILEPATH.action]: ({ rootState, dispatch }, payload) => {
		const endpoint =
			BASE_URL + "/jeet11-retail/v1.0.0/createRetailUserTarget";
		const { appType, filePath } = payload;
		const headers = {
			"x-client-app-type": appType
		};
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				filePath
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload, { headers })
			.then(data => {
				if (typeof data === "object") {
					if (
						data.statusCode === 200 &&
						"response" in data &&
						typeof data.response === "object"
					) {
						return data.response;
					} else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[FETCH_ALL_DSTR_TARGETS.action]: ({ rootState, dispatch }, payload) => {
		const { appType } = payload;
		const endpoint = BASE_URL + `/jeet11-retail/v1.0.0/getTertiaryTarget`;
		const headers = {
			"x-client-app-type": appType
		};
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload, { headers })
			.then(data => {
				if (typeof data === "object") {
					if (
						data.statusCode === 200 &&
						"response" in data &&
						typeof data.response === "object"
					) {
						return data.response;
					} else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[UPDATE_DSTR_CSV_FILEPATH.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/setTertiaryTarget";
		const { appType, filePath } = payload;
		const headers = {
			"x-client-app-type": appType
		};
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				filePath
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload, { headers })
			.then(data => {
				if (typeof data === "object") {
					if (
						data.statusCode === 200 &&
						"response" in data &&
						typeof data.response === "object"
					) {
						return data.response;
					} else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[FETCH_RETAIL_ALERTS.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/getRetailAlerts";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if (typeof data === "object") {
					if (
						data.statusCode === 200 &&
						data.response &&
						typeof data.response === "object"
					)
						return data.response;
					else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[ADD_RETAIL_ALERTS.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/addRetailAlerts";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if (typeof data === "object") {
					if (data.statusCode === 200) return data.response;
					else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
			})
			.finally(() => {
				dispatch(
					SHOW_ALERT.dispatch,
					{
						text:
							"Your Notification has been successfully created. You can refresh and check this in a minute."
					},
					{ root: true }
				);
			});
	},
	[RESCHEDULE_RETAIL_ALERTS.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/rescheduleAlerts";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if (typeof data === "object") {
					if (data.statusCode === 200) return data.response;
					else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[GET_USER_ACTIVE_ALERTS.action]: ({ rootState, dispatch }) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/getUserActiveAlert";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if (typeof data === "object") {
					if (data.statusCode === 200) return data.response;
					else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[CHANGE_ALERT_STATUS.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/changeAlertStatus";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if (typeof data === "object") {
					if (data.statusCode === 200) return data.response;
					else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[FETCH_USER_METRIC_LEADERBOARDS.action]: (
		{ rootState, dispatch },
		payload
	) => {
		const endpoint =
			BASE_URL + "/jeet11-retail/v1.0.0/getUserMetricLeaderboards";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if (typeof data === "object") {
					if (data.statusCode === 200) return data.response;
					else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[FETCH_METRIC_LEADERBOARDS.action]: ({ rootState, dispatch }, payload) => {
		const endpoint =
			BASE_URL + "/jeet11-retail/v1.0.0/getMetricLeaderboard";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if (typeof data === "object") {
					if (data.statusCode === 200) return data.response;
					else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[UPSERT_METRIC_LEADERBOARDS.action]: ({ rootState, dispatch }, payload) => {
		const endpoint =
			BASE_URL + "/jeet11-retail/v1.0.0/upsertMetricLeaderboard";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if (typeof data === "object") {
					if (data.statusCode === 200) return data.response;
					else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[RETAILERS_VISIT_LIST.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/retailersVisitList";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if (typeof data === "object") {
					if (data.statusCode === 200) return data.response;
					else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[UPDATE_RETAILER_STATUS.action]: ({ rootState, dispatch }, payload) => {
		const endpoint =
			BASE_URL + "/jeet11-retail/v1.0.0/updateRetailerStatus";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if (typeof data === "object") {
					if (data.statusCode === 200) {
						dispatch(
							SHOW_ALERT.dispatch,
							{ text: "Updated Successfully" },
							{ root: true }
						);
						return data.response;
					} else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[RETAIL_VISIT.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/retailVisit";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if (typeof data === "object") {
					if (data.statusCode === 200) {
						dispatch(
							SHOW_ALERT.dispatch,
							{ text: "Visited Successfully" },
							{ root: true }
						);
						return data.statusCode;
					} else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[GET_RETAILER_OTP.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/retailerOtp";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if (typeof data === "object") {
					if (data.statusCode === 200) return data.response;
					else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[UPDATE_EXISTING_RETAILER.action]: ({ rootState, dispatch }, payload) => {
		const endpoint =
			BASE_URL + "/jeet11-retail/v1.0.0/updateExistingRetailer";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if (typeof data === "object") {
					if (data.statusCode === 200) {
						dispatch(
							SHOW_ALERT.dispatch,
							{ text: "Updated Successfully" },
							{ root: true }
						);
						return data.response;
					} else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[FETCH_ALL_RETAIL_VISITS.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/allRetailVisits";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if (typeof data === "object") {
					if (data.statusCode === 200) return data.response;
					else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[GET_RETAILER_VISIT_HISTORY.action]: ({ rootState, dispatch }, payload) => {
		const endpoint =
			BASE_URL + "/jeet11-retail/v1.0.0/getRetailerVisitHistory";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if (typeof data === "object") {
					if (data.statusCode === 200) return data.response;
					else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[SCHEDULE_RETAIL_VISIT.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/scheduleVisit";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if (typeof data === "object") {
					if (data.statusCode === 200) {
						dispatch(
							SHOW_ALERT.dispatch,
							{ text: "Updated Successfully" },
							{ root: true }
						);
						return data.statusCode;
					} else if ("errMsg" in data) {
						errMsg = data.errMsg;
					}
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	}
};

const mutations = {};

export default {
	namespaced: true,
	state,
	actions,
	mutations
};
